// extracted by mini-css-extract-plugin
module.exports = {"button":"DownloadAgendaPDFButton_button__2sQtG","pdfIcon":"DownloadAgendaPDFButton_pdfIcon__3Ry7c"};